{
  "longPressMessage": "Önizlemeyi açmak için uzun süre basılı tutun"
}
